import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  // Get the current location object
  const { pathname } = useLocation();

  // Use useEffect to trigger the scroll action
  useEffect(() => {
    // Scroll the window to the top left corner (0, 0)
    window.scrollTo(0, 60);

    // Optionally, add smooth scrolling (can sometimes feel slightly slower)
    // window.scroll({ top: 0, left: 0, behavior: 'smooth' });

  }, [pathname]); // Dependency array: Run this effect only when the pathname changes

  // This component doesn't render anything itself
  return null;
}

export default ScrollToTop; 